var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner",attrs:{"role":"status","aria-live":"polite"}},[_c('span',{staticClass:"spinner__circle"})])
}]

export { render, staticRenderFns }